import { APIService } from '../../shared/services/APIService';
import { DiagramComment } from '../models/DiagramComment';

export class DiagramCommentService extends APIService {
  getAllComments() {
    return this.http.get('/diagramComments');
  }

  
}